import { render, staticRenderFns } from "./UiAgentExpences.vue?vue&type=template&id=daf3b670&lang=pug&"
import script from "./UiAgentExpences.vue?vue&type=script&lang=js&"
export * from "./UiAgentExpences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports